import theme from '@styles/theme';
export default {
  fullModeContainer: {
    width: '100vw',
    height: `100%`,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    left: 0,
    background: theme.rawColors.neutralWhite,
    zIndex: theme.zIndex.documentHigh
  },
  fullModeContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  fullModeImg: {
    position: 'relative',
    width: 'auto',
    height: 'calc(100% - 150px)',
    img: {
      position: 'relative',
      width: 'auto',
      height: '100%'
    },
    margin: '0 auto',
    flexShrink: 0,
    flexGrow: 1
  },
  sliderContainer: {
    width: '100%',
    height: '150px',
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: ['space-around', 'space-between'],
    alignItems: 'center',
    flexWrap: 'no-wrap',
    '.swiper-slide': {
      width: 'auto'
    }
  },
  sliderImg: {
    position: 'relative',
    height: '80px',
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    img: {
      width: 'auto',
      height: '100%'
    }
  },
  sliderArrowButton: (dir: 'left' | 'right', hidden = false) => ({
    position: 'absolute',
    bottom: '40px',
    zIndex: hidden ? 0 : theme.zIndex.documentUp,
    opacity: hidden ? 0 : theme.zIndex.documentUp,
    transition: 'opacity 0.2s linear',
    [dir]: '2%',
    button: {
      width: '64px',
      height: '64px'
    }
  }),
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 24,
    zIndex: theme.zIndex.documentHigh
  }
};